import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgEvents = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height={24}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <title>events</title>
        <path
            clip-rule="evenodd"
            d="M12.6387 1.6665C12.9608 1.6665 13.2216 1.94641 13.2217 2.2915V3.3335H15.5557C16.1999 3.33361 16.7217 3.89321 16.7217 4.5835V16.6665C16.7217 17.3568 16.1999 17.9164 15.5557 17.9165H3.11133C2.467 17.9165 1.94434 17.3569 1.94434 16.6665V4.5835C1.94434 3.89314 2.467 3.3335 3.11133 3.3335H5.44434V2.2915C5.44443 1.94653 5.70539 1.6667 6.02734 1.6665C6.34945 1.6665 6.61123 1.94641 6.61133 2.2915V3.3335H12.0557V2.2915C12.0558 1.94645 12.3166 1.66657 12.6387 1.6665ZM3.11133 16.6665H15.5557V8.3335H3.11133V16.6665ZM3.11133 7.0835H15.5557V4.5835H13.2217V5.2085C13.2216 5.55361 12.9608 5.8335 12.6387 5.8335C12.3166 5.83343 12.0557 5.55357 12.0557 5.2085V4.5835H6.61133V5.2085C6.61126 5.55361 6.34947 5.8335 6.02734 5.8335C5.70538 5.8333 5.44441 5.55349 5.44434 5.2085V4.5835H3.11133V7.0835Z"
            fill-rule="evenodd"
        />
    </svg>
);

export const EventsIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgEvents}
        fontSize={fontSize}
    />
);
